( function( $ ) {

$(document).ready(function(){
// $('.f-q-wrap').on('click', function(e){
//   e.preventDefault();
//   var n = $(this).next('.f-a-wrap');
// 	e.preventDefault();
// 	if ($(this).parent().hasClass('active')) {
// 		$(n).slideUp();
// 		$(this).parent().removeClass('active');
// 	}
// 	else {
// 		$('.f-a-wrap').slideUp();
// 		$('.faq-block').removeClass('active');
// 		$(this).parent().addClass('active');
// 		$(n).slideDown();
// 	}
        
// });



   
  $('#add-dw').on('click', function(e){
	e.preventDefault();
		$('html').addClass('show-it');
        
});

    $('#clear-dw').on('click', function(e){
	e.preventDefault();
		$('html').removeClass('show-it');
        
});
	$('.option-link').on('click', function(g){
	g.preventDefault();
		var id = $(this).attr('id');
		var v = $(this).attr('data-cart');
		var p = $(this).attr('data-price');
		$('.option-link').removeClass('active');
		$('#'+id).addClass('active');
		$('#size').text(id);
		$('#product_option').val(v);
        
});

});
} )( jQuery );

